function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 29 \\u2013 194",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 4977"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 4357",
    style: {
      clipPath: "url(#h2rm4q85ra)"
    },
    transform: "translate(0 .946)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5376",
    d: "M19.379 9.175a.646.646 0 0 1-.644-.647 7.227 7.227 0 0 0-7.2-7.234A7.139 7.139 0 0 0 6.44 3.413a.646.646 0 0 1-.911-.913 8.415 8.415 0 0 1 6-2.5 8.519 8.519 0 0 1 8.491 8.528.646.646 0 0 1-.644.647",
    transform: "translate(-1.552)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5377",
    d: "M10.591 20.235A8.519 8.519 0 0 1 2.1 11.708a.645.645 0 1 1 1.289 0 7.225 7.225 0 0 0 7.2 7.233 7.141 7.141 0 0 0 5.093-2.118.642.642 0 0 1 .911 0 .649.649 0 0 1 0 .915 8.417 8.417 0 0 1-6 2.5",
    transform: "translate(-.61 -3.181)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5378",
    d: "M3.688 12.765a.64.64 0 0 1-.455-.19l-1.066-1.07L1.1 12.576a.642.642 0 0 1-.911 0 .649.649 0 0 1 0-.916l1.521-1.527a.643.643 0 0 1 .912 0l1.521 1.527a.649.649 0 0 1 0 .916.64.64 0 0 1-.455.19",
    transform: "translate(0 -2.859)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5379",
    d: "M24.2 12.858a.643.643 0 0 1-.455-.19l-1.523-1.528a.648.648 0 0 1 0-.915.641.641 0 0 1 .912 0L24.2 11.3l1.066-1.07a.64.64 0 0 1 .911 0 .648.648 0 0 1 0 .915l-1.522 1.528a.643.643 0 0 1-.455.19",
    transform: "translate(-6.402 -2.886)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5380",
    d: "M16.345 12.49a.64.64 0 0 1-.455-.19l-2.54-2.449a.649.649 0 0 1-.189-.457V5.037a.644.644 0 1 1 1.288 0v4.088l2.351 2.26a.649.649 0 0 1 0 .915.64.64 0 0 1-.455.19",
    transform: "translate(-3.824 -.866)",
    style: {
      fill: "currentColor"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtime);
export default __webpack_public_path__ + "static/media/realtime.4e7ead7849f878ca323b488c89ba52e2.svg";
export { ForwardRef as ReactComponent };